import { DetailedStep, StepId } from '../types';
import { DescriptionStep, ResultStep } from '../steps';
import {
  PreparationStepWrapper,
  DemolitionStepWrapper,
  GrosOeuvreStepWrapper,
  VRDStepWrapper,
  IsolationStepWrapper,
  CloisonsStepWrapper,
  TechniqueStepWrapper,
  SanitaireStepWrapper,
  RevetementsStepWrapper,
  MenuiserieStepWrapper,
  FinitionsStepWrapper,
  ExterieursStepWrapper
} from '../CategoryStepWrappers.tsx';

export const DETAILED_STEPS: DetailedStep[] = [
  {
    id: 'description',
    title: 'Description du bien',
    description: 'Où et quoi ?',
    component: DescriptionStep
  },
  {
    id: 'preparation',
    title: 'Préparation & Études',
    description: 'Bien démarrer',
    component: PreparationStepWrapper
  },
  {
    id: 'demolition',
    title: 'Démolition',
    description: 'Faire place nette',
    component: DemolitionStepWrapper
  },
  {
    id: 'gros-oeuvre',
    title: 'Gros œuvre',
    description: 'Restructurer',
    component: GrosOeuvreStepWrapper
  },
  {
    id: 'vrd',
    title: 'VRD',
    description: 'Alimenter',
    component: VRDStepWrapper
  },
  {
    id: 'isolation',
    title: 'Isolation et Étanchéité',
    description: 'Isoler',
    component: IsolationStepWrapper
  },
  {
    id: 'cloisons',
    title: 'Cloisons & Aménagement',
    description: 'Aménager',
    component: CloisonsStepWrapper
  },
  {
    id: 'technique',
    title: 'Electricité, etc.',
    description: 'Rendre fonctionnel',
    component: TechniqueStepWrapper
  },
  {
    id: 'sanitaire',
    title: 'Sanitaire et hygiène',
    description: 'Se laver',
    component: SanitaireStepWrapper
  },
  {
    id: 'revetements',
    title: 'Revêtements',
    description: 'Recouvrir les surfaces',
    component: RevetementsStepWrapper
  },
  {
    id: 'menuiserie',
    title: 'Menuiseries',
    description: 'Portes et fenêtres',
    component: MenuiserieStepWrapper
  },
  {
    id: 'finitions',
    title: 'Finitions',
    description: 'Décorer',
    component: FinitionsStepWrapper
  },
  {
    id: 'exterieurs',
    title: 'Extérieurs',
    description: 'Autour du bien',
    component: ExterieursStepWrapper
  },
  {
    id: 'resultat',
    title: 'Résultat',
    description: 'Combien ça coûte ?',
    component: ResultStep
  }
];

export const getNextStep = (currentStepId: StepId): StepId | null => {
  const currentIndex = DETAILED_STEPS.findIndex(step => step.id === currentStepId);
  if (currentIndex < DETAILED_STEPS.length - 1) {
    return DETAILED_STEPS[currentIndex + 1].id;
  }
  return null;
};

export const getPreviousStep = (currentStepId: StepId): StepId | null => {
  const currentIndex = DETAILED_STEPS.findIndex(step => step.id === currentStepId);
  if (currentIndex > 0) {
    return DETAILED_STEPS[currentIndex - 1].id;
  }
  return null;
};

export type { StepId } from '../types/steps';
